<template>
<section class="order-saving">
    <span class="order-saving__title">쿠폰 사용</span>
    <div class="order-saving__contents">
        <div class="order-saving__block">
            <span class="order-saving__subtitle">상품 / 주문쿠폰 사용</span>
            <div class="order-saving__form">
                <div class="input input--red"><input :value="totalCouponAmount.format()" disabled readonly><span class="currency-unit">원</span></div>
                <button class="button button--mouse" type="button" @click="$refs.modal.open()"><span>쿠폰사용</span></button>
                <span class="left-text">사용가능 쿠폰 : {{ coupons.length }}장</span>
            </div>
        </div>
    </div>
    <modal-product-coupons ref="modal" v-model="productCoupons" :coupons="coupons" :carts="carts" @input="$emit('input', productCoupons)"></modal-product-coupons>
</section>
</template>

<script>
import ModalProductCoupons from "@/components/client/shop/modal-product-coupons.vue";

export default {
    components: {
        ModalProductCoupons
    },
    props: {
        value: { type: Array, default: null },
        coupons: { type: Array, default: null },
        carts: { type: Array, default: null },
        maxAmount: { type: Number, default: 0 }
    },
    data(){
        return {
            productCoupons: this.$props.value || [],
        };
    },
    methods: {
        open(){

        },
        close(){

        },
    },
    computed: {
        totalCouponAmount(){
            return this.productCoupons.reduce((totalCouponAmount, coupon) => totalCouponAmount + this.$getCouponAmount(coupon, this.$getSaleAmount(coupon.pickup)), 0);
        },
        payload(){
            return this.$store.state.payload || {};
        },
        scope(){
            return this.payload.scope || [];
        }
    }
}
</script>